var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import ProductCardTippingHazardWarningStyle from './ProductCardTippingHazardWarningStyle.js';
const AU_TIPPING_HAZARD_CODE = '00911';
/**
 * A warning about the risk of tip-overs and the importance of anchoring must be included in the description of the toppling furniture items in relation to the product information, for the Australian market.
 */
export default class ProductCardTippingHazardWarning extends KompisElement {
    render() {
        if (!this.showTippingHazardWarning()) {
            return html `
				<style>
					:host {
						display: none;
					}
				</style>
			`;
        }
        return html `
			<style>
				${ProductCardTippingHazardWarningStyle.getStyle()}
			</style>

			${this.getTippingHazardWarning()}
		`;
    }
    showTippingHazardWarning() {
        return (this.product.content?.complianceInformation?.some((info) => info.datasetCode === AU_TIPPING_HAZARD_CODE) ?? false);
    }
    getTippingHazardWarning() {
        return html `<div class="tipping-hazard-warning">${this.getImage()} ${this.getText()}</div>`;
    }
    getImage() {
        const tippingHazardMedia = this.product.content?.complianceInformation?.find((info) => info.datasetCode === AU_TIPPING_HAZARD_CODE && info.media)?.media;
        if (!tippingHazardMedia) {
            return null;
        }
        const svgMedia = this.findMediaItem(tippingHazardMedia, '00017');
        const jpgMedia = this.findMediaItem(tippingHazardMedia, '00001');
        const imageUrl = svgMedia?.url ?? jpgMedia?.url;
        if (!imageUrl) {
            return null;
        }
        return html `<img src="${imageUrl}" alt="" />`;
    }
    findMediaItem(media, fileTypeCode) {
        return media.find((item) => item.fileTypeCode === fileTypeCode) ?? null;
    }
    getText() {
        const tippingHazardTexts = this.product.content?.complianceInformation
            ?.filter((info) => info.datasetCode === AU_TIPPING_HAZARD_CODE && !info.media && info.text)
            ?.map((info) => info.text);
        if (!tippingHazardTexts || tippingHazardTexts.length === 0) {
            return null;
        }
        return html `<p class="${Text.classnames({ body: { m: true } })}">
			${tippingHazardTexts.map((text) => {
            return html `${text}<br />`;
        })}
		</p>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], ProductCardTippingHazardWarning.prototype, "product", void 0);
//# sourceMappingURL=ProductCardTippingHazardWarning.js.map